import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (id: string) => {
    if (isHomePage) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = `/#${id}`;
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-50 to-gray-100 pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <img
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/f7c8e59443071922ab03ad54f161aa96.png"
              alt="سماعتي"
              className="h-20 w-auto mb-6"
            />
            <p className="text-base text-gray-600 leading-relaxed">
              العناية الخاصة بسماعتك وسمعك أصبحت مسؤوليتنا. حلول مبتكرة لتحسين سمعك.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold text-gray-800 mb-6">روابط سريعة</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-base text-gray-600 hover:text-[#184187] transition-colors cursor-pointer">
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-base text-gray-600 hover:text-[#184187] transition-colors cursor-pointer">
                  من نحن
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-base text-gray-600 hover:text-[#184187] transition-colors cursor-pointer">
                  خدماتنا
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-base text-gray-600 hover:text-[#184187] transition-colors cursor-pointer">
                  التوظيف
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold text-gray-800 mb-6">خدماتنا</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-base text-gray-600 hover:text-[#184187] transition-colors cursor-pointer text-right"
                >
                  اختبارات السمع
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-base text-gray-600 hover:text-[#184187] transition-colors cursor-pointer text-right"
                >
                  برمجة السماعات
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-base text-gray-600 hover:text-[#184187] transition-colors cursor-pointer text-right"
                >
                  الصيانة والإصلاح
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-base text-gray-600 hover:text-[#184187] transition-colors cursor-pointer text-right"
                >
                  زيارات منزلية
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold text-gray-800 mb-6">تواصل معنا</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-xl text-[#184187] flex-shrink-0"></i>
                <a
                  href="mailto:b.alqabbani@sammaty.com"
                  className="text-base text-gray-600 hover:text-[#184187] transition-colors cursor-pointer"
                >
                  b.alqabbani@sammaty.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-xl text-[#184187] flex-shrink-0"></i>
                <a
                  href="tel:0552007272"
                  className="text-base text-gray-600 hover:text-[#184187] transition-colors cursor-pointer"
                >
                  0552007272
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-[#184187] flex-shrink-0"></i>
                <span className="text-base text-gray-600">MPS-Clinic : Sammaty</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex gap-3 mt-6">
              <a
                href="#"
                className="w-10 h-10 bg-[#184187] rounded-lg flex items-center justify-center text-white hover:bg-[#0f2d6b] transition-all hover:scale-110 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-[#184187] rounded-lg flex items-center justify-center text-white hover:bg-[#0f2d6b] transition-all hover:scale-110 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-[#184187] rounded-lg flex items-center justify-center text-white hover:bg-[#0f2d6b] transition-all hover:scale-110 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-300 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-base text-gray-600 text-center md:text-right">
              حقوق النشر &copy; 2026 جميع الحقوق محفوظة | الشروط
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-sm text-gray-400 hover:text-gray-500 transition-colors cursor-pointer"
            >
              Web Design
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
